// ExcelIcon.tsx
import React from 'react';

interface ExcelIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const ExcelIcon = ({
    width = 52,
    height = 52,
    fill = 'black',
}: ExcelIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M38.068 8.72L35.618 6H16.324C14.932 6 14.394 7.032 14.394 7.838V15.098H17.1V9.306C17.1 8.998 17.36 8.738 17.66 8.738H31.466C31.77 8.738 31.922 8.792 31.922 9.042V18.682H41.748C42.134 18.682 42.284 18.882 42.284 19.174V42.714C42.284 43.206 42.084 43.28 41.784 43.28H17.66C17.5112 43.2764 17.3697 43.2151 17.2652 43.1092C17.1607 43.0032 17.1015 42.8608 17.1 42.712V40.56H14.412V43.95C14.376 45.15 15.016 46 16.324 46H43.12C44.52 46 44.998 44.986 44.998 44.062V16.374L44.298 15.614L38.068 8.72ZM34.672 9.04L35.446 9.908L40.638 15.614L40.924 15.96H35.618C35.218 15.96 34.964 15.894 34.858 15.76C34.752 15.63 34.69 15.42 34.672 15.134V9.04ZM32.492 27.334H41.646V30.002H32.49L32.492 27.334ZM32.492 22.002H41.646V24.668H32.49L32.492 22.002ZM32.492 32.668H41.646V35.336H32.49L32.492 32.668ZM9 17.252V38.586H29.93V17.252H9ZM19.466 29.66L18.186 31.616H19.466V34H13.032L17.7 26.98L13.564 20.668H17.02L19.468 24.34L21.914 20.668H25.368L21.224 26.98L25.898 34H22.312L19.466 29.66Z"
                fill={fill}
            />
        </svg>
    );
};

export default ExcelIcon;
